// BOOK · the address: `?book=<key>` names a book only when the key is a known book.
import { BOOKS } from './model/bookConstants';

export function wantedBook(search) {
  try { const k = new URLSearchParams(search || '').get('book'); return k && BOOKS[k] ? k : null; } catch (_) { return null; }
}
